.tags {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.tags > div {
    margin: 0px 5px 5px 0px;
}
